import { render, staticRenderFns } from "./ShopCommission.vue?vue&type=template&id=e5511960&"
import script from "./ShopCommission.vue?vue&type=script&lang=js&"
export * from "./ShopCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports